export const STATUS_PARCERIA = Object.freeze({
  EM_EDICAO: "EM_EDICAO",
  FORMULARIO_RECEBIDO: "FORMULARIO_RECEBIDO",
  EM_ANALISE: "EM_ANALISE",
  EM_ARTICULACAO_E_FORMALIZACAO: "EM_ARTICULACAO_E_FORMALIZACAO",
  AGUARDANDO_APROVACAO_REITORIA: "AGUARDANDO_APROVACAO_REITORIA",
  PARCERIA_FORMALIZADA: "PARCERIA_FORMALIZADA",
  REJEITADA: "REJEITADA",
  CANCELADA: "CANCELADA",

  // Aliases retornados pelo backend para solicitação recém-enviada / aguardando análise
  PENDENTE: "FORMULARIO_RECEBIDO",
    EDICAO: "FORMULARIO_RECEBIDO",
  APROVADA: "PARCERIA_FORMALIZADA",
  REPROVADA: "REJEITADA",
});

export const STATUS_PARCERIA_LABEL = Object.freeze({
  [STATUS_PARCERIA.EM_EDICAO]: "Em edição",
  [STATUS_PARCERIA.FORMULARIO_RECEBIDO]: "Aguardando análise",
  [STATUS_PARCERIA.EM_ANALISE]: "Em análise",
  [STATUS_PARCERIA.EM_ARTICULACAO_E_FORMALIZACAO]: "Em articulação",
  [STATUS_PARCERIA.AGUARDANDO_APROVACAO_REITORIA]: "Aguardando aprovação da reitoria",
  [STATUS_PARCERIA.PARCERIA_FORMALIZADA]: "Parceria formalizada",
  [STATUS_PARCERIA.REJEITADA]: "Parceria indeferida",
  [STATUS_PARCERIA.CANCELADA]: "Parceria cancelada",
});

// Labels exibidos no painel PREX
export const STATUS_PARCERIA_LABEL_PREX = Object.freeze({
  [STATUS_PARCERIA.FORMULARIO_RECEBIDO]: "Aguardando análise",
  [STATUS_PARCERIA.EM_ANALISE]: "Em análise",
  [STATUS_PARCERIA.EM_ARTICULACAO_E_FORMALIZACAO]: "Em articulação",
  [STATUS_PARCERIA.AGUARDANDO_APROVACAO_REITORIA]: "Aguardando aprovação da reitoria",
  [STATUS_PARCERIA.PARCERIA_FORMALIZADA]: "Parceria formalizada",
  [STATUS_PARCERIA.REJEITADA]: "Parceria indeferida",
  [STATUS_PARCERIA.CANCELADA]: "Parceria cancelada",
});

export const TIPOS_PARCERIA = Object.freeze([
  { value: "EXTERNA", label: "Externa" },
  { value: "INTRA_MUROS", label: "Intramuros" },
]);

export const TIPO_PARCERIA_LABEL = Object.freeze(
  TIPOS_PARCERIA.reduce((labels, tipo) => {
    labels[tipo.value] = tipo.label;
    return labels;
  }, {})
);
